import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProgramService } from '../../services/program.service';
import { BudgetChangesService } from '../../services/budget-changes.service';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/combineLatest';
import { NavBarService } from 'app/services/nav-bar.service';

@Component({
  selector: 'app-budget-changes-modal',
  templateUrl: './budget-changes-modal.component.html',
  styleUrls: ['./budget-changes-modal.component.scss'],
})
export class BudgetChangesModalComponent implements OnInit {
  texts: any;
  ready: boolean = false;
  upperChanges: any[];
  lowerChanges: any[];
  program: any = { naam: '', weergavenummer: 0 };
  selectedTab: number = 1;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProgramService,
    private changesService: BudgetChangesService,
    private NavBarService: NavBarService
  ) {}

  ngOnInit() {
    this.route.parent.params
      .switchMap((params: Params) => this.service.getProgram(+params['id']))
      .subscribe(a => {
        if (a !== undefined) {
          this.texts = a.Teksten.Texts;
          this.program = a;
          this.ready = true;
          this.NavBarService.setData({
            title: `${this.program.Weergavenummer}. ${this.program.naam}`,
            color: this.program.Weergavenummer,
            crumbs: [
              {
                text: `${this.program.Weergavenummer}. ${this.program.naam}`,
                link: `/programma/${this.program.id}`,
                active: false,
              },
              {
                text: `Begrotingswijzigingen`,
                link: null,
                active: true,
              },
            ],
          });
        }
      });

    const upper = this.route.parent.params.switchMap((params: Params) =>
      this.changesService.getUpper(+params['id'])
    );

    const lower = this.route.parent.params.switchMap((params: Params) =>
      this.changesService.getLower(0)
    );

    const final = lower.combineLatest(upper).map(a => {
      return { files: a[0], adjustments: a[1] };
    });

    final.subscribe(a => {
      this.upperChanges = a.adjustments;
      console.log(this.upperChanges);
      this.lowerChanges = a.files;

      this.upperChanges.forEach(
        a => {
          if(a.nr_wijziging != null && a.nr_wijziging.indexOf(',') >= 0) {
          a.nr_wijziging = a.nr_wijziging.split(',').map(b => b.trim())
          } else {
            a.nr_wijziging = a.nr_wijziging ? [a.nr_wijziging]: [];
          }
      }
      );

      console.log(this.upperChanges);
    });
  }

  getFile(n) {
    var file = this.lowerChanges.find(a => a.nummer === n);
    if(file) {
      return file.bestand;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/budget-changes-modal/budget-changes-modal.component.ts